import React, { useState } from "react";
import { TextField, Box, Stack, Button } from "@mui/material";
import { toast } from 'react-hot-toast';

export const ManualInputBulkAssign = ({ manualInputBulkAssignSaveHandler, label, placeholder }) => {
  const [manualInput, setManualInput] = useState("");

  const handleSave = () => {
    if (manualInput.trim() === "") {
      toast.error("Please enter some data");
      return;
    }
    manualInputBulkAssignSaveHandler(manualInput);
  };

  return (
    <Stack direction={"column"} spacing={2} sx={{ width: "100%" }}>
      <TextField
        fullWidth
        multiline
        rows={4}
        value={manualInput}
        onChange={(e) => setManualInput(e.target.value)}
        variant="outlined"
        label={label}
        placeholder={placeholder}
      />

      <Stack direction={"row"} spacing={2}>
        <Button variant="contained" onClick={handleSave}>
          Save
        </Button>
      </Stack>
    </Stack>
  );
};
